import { cn } from '@/lib/utils/cn'
import { COURT_STATUS_CATALOG, type VenueCourtStatus } from '@/lib/venue/courtTypes'

/**
 * 코트 상태 3종 라디오 카드(Figma `코트 추가`/`코트 상세 설정` 실측 — 라벨+설명문).
 * `VenueTriStateField.tsx` 의 세그먼트 스타일과 달리, 상태를 바꿨을 때의 결과를 설명문으로 안내한다.
 */
export function CourtStatusField({
  value,
  onChange,
}: {
  value: VenueCourtStatus
  onChange: (value: VenueCourtStatus) => void
}) {
  return (
    <div role="radiogroup" aria-label="코트 상태" className="space-y-2">
      {COURT_STATUS_CATALOG.map((option) => {
        const checked = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={checked}
            aria-label={option.label}
            onClick={() => {
              onChange(option.value)
            }}
            className={cn(
              'flex w-full items-start gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors',
              checked ? 'border-brand-500 bg-brand-50' : 'border-slateish-300 hover:bg-slateish-50'
            )}
          >
            <span
              aria-hidden
              className={cn(
                'mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border',
                checked ? 'border-brand-500' : 'border-slateish-400'
              )}
            >
              {checked ? <span className="h-2 w-2 rounded-full bg-brand-500" /> : null}
            </span>
            <span>
              <span className="block text-sm font-medium text-ink-700">{option.label}</span>
              <span className="block text-xs text-slateish-500">{option.description}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}
